import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Navbar as BootstrapNavbar, Nav, NavDropdown } from 'react-bootstrap';
import '../css/navbar.css';
import logo from '../img/logo.png'

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);

  // Function to handle closing the navbar after clicking on a link
  const handleNavItemClick = () => {
    setExpanded(false); // Close the navbar after a link click
  };

  // Function to prevent closing the dropdown when clicking inside the dropdown
  const handleDropdownClick = (e) => {
    e.stopPropagation(); // Prevent event propagation to avoid closing the dropdown
  };

  return (
    <BootstrapNavbar expand="lg" expanded={expanded} className="navbar-light">
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" onClick={handleNavItemClick}>
        <img src={logo}/>   HOPE RISE MULTI <span>SPECIALITY HOSPITAL</span>
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle
          aria-controls="navbarSupportedContent"
          onClick={() => setExpanded(!expanded)} // Toggle the navbar collapse
        />
        <BootstrapNavbar.Collapse id="navbarSupportedContent">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>Home</Nav.Link>

            <NavDropdown
              title="About"
              id="about-dropdown"
              className="custom-dropdown-title"
              onClick={handleDropdownClick} // Prevent dropdown from closing
            >
              <NavDropdown.Item as={Link} to="/About" onClick={handleNavItemClick}>
                About Hospital
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>Doctors</Nav.Link>

            <NavDropdown
              title="Speciality"
              id="services-dropdown"
              className="custom-dropdown-title"
              onClick={handleDropdownClick} // Prevent dropdown from closing
            >
              <NavDropdown.Item as={Link} to="/BreastCancer" onClick={handleNavItemClick}>
                EMERGENCY
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>EMERGENCY X-RAY</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>PHARMACY 24*7</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>ICU/Ventilator</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>PHYSIOTHERAPY</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>PATHOLOGY</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>AMBULANCE</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Dialysis</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Plastic Surgery</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Treatment"
              id="treatment-dropdown"
              className="custom-dropdown-title"
              onClick={handleDropdownClick} // Prevent dropdown from closing
            >
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>General Surgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Maxillofacial Surgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Neurosurgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>ENT</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Uro Surgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Cardiology</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Ortho Surgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Advanced Endoscopy</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Gynecology</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Pediatric Surgery</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Physiotherapy</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Hepatology</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/" onClick={handleNavItemClick}>Gastroenterology</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Media"
              id="media-dropdown"
              className="custom-dropdown-title"
              onClick={handleDropdownClick} // Prevent dropdown from closing
            >
              <NavDropdown.Item as={Link} to="/Photoes" onClick={handleNavItemClick}>Photos</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Videos" onClick={handleNavItemClick}>Videos</NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/Contact" onClick={handleNavItemClick}>Contact</Nav.Link>
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>Career</Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
